import { CourseInstance, CourseParticipationOutcome } from "@/learning/instances/Models";;

export enum CourseTemplateTagType {
    Main = "Main",
}

export interface CourseParticipationOutcomeWrapper extends CourseParticipationOutcome {
    fathersCourseTemplates: string[];
    relatedTemplateTags: CourseTemplateTagType[];
    relatedUpdateCourseId?: string
}

export interface CourseInstanceWrapper extends CourseInstance {
    subscribedNumber: number;
}